export default __webpack_public_path__ + "static/media/LogoVertical.e9c01bd7.svg";